/**
 * Force closes all current processes and reloads the page when the forbidden error occurs
 * This ensures clean state management and proper cleanup before reload
 * It will inherit the current behavior from Rail View in the current implementation
 * Behavior:
 * - 403: Forbidden
 * When reload, it will redirect to the home page  and show flash message
 * - 401: Unauthorized
 * When reload, it will redirect to the list offices page and show flash message
 */

import { isAuthError, isForbiddenError } from '@/context/services/type';

const isInvoiceReportAuthOrForbidden = (statusCode?: number): boolean =>
  !!(isAuthError(statusCode) || isForbiddenError(statusCode));

export const handleInvoiceReportForbiddenWithEarlyReturn = (
  statusCode?: number
): boolean => {
  const isForbidden = isInvoiceReportAuthOrForbidden(statusCode);
  if (isForbidden) {
    location.reload();
  }
  return isForbidden;
};

export const handleInvoiceReportForbiddenStatusCode = (
  statusCode?: number
): void => {
  handleInvoiceReportForbiddenWithEarlyReturn(statusCode);
};
